import React, { useState } from 'react';

const PaymentModal = ({ total, onConfirm, onClose }) => {
  const [payMethod, setPayMethod] = useState(null); // 'WECHAT', 'ALIPAY', 'CASH'

  return (
    <div className="modal-overlay" onClick={onClose} style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
    }}>
      <div className="pop-art-modal" onClick={(e) => e.stopPropagation()} style={{
        background: 'white', border: '5px solid black', padding: '30px', 
        boxShadow: '10px 10px 0px #000', textAlign: 'center', width: '90%', maxWidth: '400px'
      }}>
        
        {!payMethod ? (
          <>
            <h3 style={{ fontSize: '26px', fontWeight: '900', marginBottom: '20px' }}>选择支付方式</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <button onClick={() => setPayMethod('WECHAT')} style={{ padding: '15px', background: '#07C160', color: 'white', border: '4px solid black', fontWeight: '900', fontSize: '20px', cursor: 'pointer', boxShadow: '5px 5px 0 #000' }}>
                🟢 微信支付
              </button>
              <button onClick={() => setPayMethod('ALIPAY')} style={{ padding: '15px', background: '#1677FF', color: 'white', border: '4px solid black', fontWeight: '900', fontSize: '20px', cursor: 'pointer', boxShadow: '5px 5px 0 #000' }}>
                🔵 支付宝支付
              </button>
              <button onClick={() => setPayMethod('CASH')} style={{ padding: '15px', background: '#FF9800', color: 'white', border: '4px solid black', fontWeight: '900', fontSize: '20px', cursor: 'pointer', boxShadow: '5px 5px 0 #000' }}>
                💵 吧台现金支付
              </button>
              <button onClick={onClose} style={{ marginTop: '10px', padding: '12px', background: '#ff5252', color: 'white', border: '4px solid black', fontWeight: '900', fontSize: '18px', cursor: 'pointer', boxShadow: '5px 5px 0 #000' }}>
                取 消 支 付
              </button>
            </div>
          </>
        ) : (
          <div className="qr-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            
            {/* 现金支付界面 */}
            {payMethod === 'CASH' && (
              <div style={{ padding: '20px', border: '4px dashed #FF9800', marginBottom: '20px', background: '#fff3e0' }}>
                <h3 style={{ fontSize: '24px', fontWeight: '900', color: '#e65100' }}>💵 现金支付</h3>
                <p style={{ fontWeight: 'bold', fontSize: '18px' }}>请前往吧台将 ￥{total} 现金交给店员</p>
              </div>
            )}

            {/* 微信/支付宝二维码界面 */}
            {payMethod !== 'CASH' && (
              <>
                <img 
                  src={payMethod === 'WECHAT' ? process.env.PUBLIC_URL + '/qr-wechat.jpg' : process.env.PUBLIC_URL + '/qr-alipay.jpg'} 
                  alt="收款码" 
                  style={{ width: '220px', height: '220px', objectFit: 'contain', border: '4px solid black', marginBottom: '10px', background: '#f5f5f5' }}
                />
                
                {/* 微信专属提示 */}
                {payMethod === 'WECHAT' && (
                  <p style={{ fontWeight: '900', color: '#07C160', fontSize: '16px', margin: '5px 0 15px 0' }}>
                    👇 长按图片识别二维码即可跳转支付
                  </p>
                )}

                {/* 支付宝专属提示与跳转按钮 */}
                {payMethod === 'ALIPAY' && (
                  <div style={{ marginBottom: '15px' }}>
                    <p style={{ fontWeight: 'bold', color: '#1677FF', fontSize: '14px', margin: '5px 0 10px 0' }}>
                      支付宝内可长按识别。其他环境请直接店内扫码。
                    </p>
                    <a href="alipays://" style={{ display: 'inline-block', padding: '10px 20px', background: '#1677FF', color: 'white', textDecoration: 'none', fontWeight: '900', border: '3px solid black', boxShadow: '3px 3px 0 #000' }}>
                      点击此前往支付宝
                    </a>
                  </div>
                )}
                
                <p style={{ fontWeight: '900', fontSize: '22px', color: '#ffb300', WebkitTextStroke: '1px #000', margin: '0 0 15px 0' }}>
                  需支付 ￥{total}
                </p>
              </>
            )}

            {/* 底部操作区 */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
              <button 
                onClick={() => onConfirm(payMethod)} // 把支付方式传回给 App.js 记账
                style={{ padding: '15px', background: '#ffd54f', border: '4px solid black', fontWeight: '900', fontSize: '20px', cursor: 'pointer', boxShadow: '5px 5px 0 #000' }}
              >
                ✅ 我已完成付款告知店员，提交订单
              </button>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button onClick={() => setPayMethod(null)} style={{ flex: 1, padding: '12px', background: 'white', border: '4px solid black', fontWeight: '900', cursor: 'pointer', boxShadow: '4px 4px 0 #000' }}>
                  返回重选
                </button>
                <button onClick={onClose} style={{ flex: 1, padding: '12px', background: '#ff5252', color: 'white', border: '4px solid black', fontWeight: '900', cursor: 'pointer', boxShadow: '4px 4px 0 #000' }}>
                  取消订单
                </button>
              </div>
            </div>

          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentModal;